module.exports = __webpack_public_path__ + "static/drone_video-f44117dae7925e9c2f328344a1795adb.mp4";